module.exports = __webpack_public_path__ + "static/media/image4.44f519ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image4.jpg
// module id = 649
// module chunks = 0